import React from 'react';

export interface TestManagerNotesProps {
  localNotes: string;
  isAddingNotes: boolean;
  notesTextareaRef: React.RefObject<HTMLTextAreaElement | null>;
  onNotesChangeLocal: (notes: string) => void;
  onNotesSave: () => void;
  onNotesKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onFocus: () => void;
}

export const TestManagerNotes: React.FC<TestManagerNotesProps> = ({
  localNotes,
  isAddingNotes,
  notesTextareaRef,
  onNotesChangeLocal,
  onNotesSave,
  onNotesKeyDown,
  onFocus,
}) => (
  <div>
    <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-3 flex items-center gap-2">
      <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
      Notatki
      {isAddingNotes && (
        <span className="text-sm text-blue-500 dark:text-blue-400 ml-2">(Tryb edycji - naciśnij &apos;esc&apos; aby zakończyć)</span>
      )}
    </h3>
    <textarea
      ref={notesTextareaRef as React.RefObject<HTMLTextAreaElement>}
      value={localNotes}
      onChange={(e) => onNotesChangeLocal(e.target.value)}
      onBlur={onNotesSave}
      onKeyDown={onNotesKeyDown}
      onFocus={onFocus}
      className={`w-full h-32 p-6 bg-gray-50 dark:bg-slate-600/50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 resize-none transition-all duration-200 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-500 ${
        isAddingNotes ? 'ring-2 ring-blue-500' : ''
      }`}
      placeholder="Dodaj notatki do testu... (naciśnij 't' aby szybko dodać notatki, Enter aby zapisać)"
    />
  </div>
);
